import React from 'react';
import './operator-list-item.scss';
import { IOperatorsDTO } from '../../../../api/operators.dao';
import Text from '../../../global/text/text';

const OperatorsListItem = ({ firstName, lastName, email }: IOperatorsDTO) => {

    return (
        <tr className='operators-item'>
            <td className='hoverable'>
                <div className='operators-item__column'>
                    <Text className='operators-item__text' message={firstName} withEllipsis />
                </div>
            </td>
            <td className='hoverable'>
                <div className='operators-item__column'>
                    <Text className='operators-item__text' message={lastName} withEllipsis />
                </div>
            </td>
            <td className='hoverable'>
                <div className='operators-item__column'>
                    <Text className='operators-item__text' message={email} withEllipsis />
                </div>
            </td>
        </tr>
    );
};

export { OperatorsListItem };